import { useEffect } from 'react';
import { useDrawingStore } from '../stores/drawingStore';
import { getToolFromKey, isLayerShortcut, getLayerActionFromEvent } from '../utils/keyboardUtils';
import { devLog } from '../runtime/logger';

export const useKeyboard = () => {
  const { setCurrentTool } = useDrawingStore();

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      // Prevent shortcuts when typing in input fields
      if (event.target instanceof HTMLInputElement || event.target instanceof HTMLTextAreaElement) {
        return;
      }

      // Tool shortcuts (1-8)
      if (getToolFromKey(event.key)) {
        event.preventDefault();
        const tool = getToolFromKey(event.key);
        if (tool) {
          setCurrentTool(tool);
        }
        return;
      }

      // Space bar for hand tool
      if (event.key === ' ' && !event.ctrlKey && !event.shiftKey && !event.metaKey) {
        event.preventDefault();
        setCurrentTool('pencil'); // For now, just toggle pencil
        return;
      }

      // Layer shortcuts (Cmd+arrows)
      if (isLayerShortcut(event)) {
        event.preventDefault();
        const action = getLayerActionFromEvent(event);
        if (action) {
          // TODO: Implement layer actions
          devLog('Layer action:', action);
        }
        return;
      }

      // Escape to deselect
      if (event.key === 'Escape') {
        event.preventDefault();
        // TODO: Implement deselect functionality
        devLog('Deselect all');
        return;
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [setCurrentTool]);
};
